module.exports = __webpack_public_path__ + "img/backgound-grow-tree.81f48bf3.png";